import React from 'react'

import './email.css'

const Email = () => {
  return (
    <>
        <>admin@gloriaserenityhomehealth.net</>
    </>
  )
}

export default Email